import styled from 'styled-components';

const ViewAndLegendContainer = styled.div`
  flex: 1;
  position: relative;
  display: flex;
`;
export { ViewAndLegendContainer };
